import constants from 'constants/index'

const chipStatusColor = (status, classes) => {
  switch (status) {
    case constants.partner.ACTIVE_STATUS:
      return classes.chipActive
    case constants.partner.INACTIVE_STATUS:
      return classes.chipInactive
    case constants.partner.ONBOARD_STATUS:
      return classes.chipOnBoard
    case constants.partner.WAITING_APPROVAL_STATUS:
      return classes.chipWaitingApproval
    case constants.partner.REPROVED_STATUS:
      return classes.chipReproved
    case constants.partner.DISABLED_STATUS:
      return classes.chipDisabled
    default:
      return null
  }
}

export default chipStatusColor
